import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {AbstractHttpService} from './abstract-http-service';

@Injectable({
  providedIn: 'root'
})
export class OfferRegistryProcessorSyncService extends AbstractHttpService {
  private options = {
    headers: this.contentTypeJsonHeaders,
    withCredentials: true
  };

  constructor(private httpClient: HttpClient) {
    super();
  }

  /**
   * Calls the private-offer registry sync endpoint so the backend can reconcile
   * `private_offer_data_registry` rows for all active standard offer sets for the given account.
   */
  processForAllStandardOfferSets(accountId: number): Observable<void> {
    const requestUrl = `//${environment.autoDomain}:${environment.autoPort}/api/offers-registry/process`;

    const response = this.httpClient.post<void>(requestUrl,
      {
        accountId
      },
      this.options
    ).pipe(
      catchError(this.handleError)
    );

    return response;
  }

  /**
   * Calls the private-offer sync endpoint so the backend can sync
   * `private_offer_data_registry` rows for all active standard offer sets for the given account.
   */
  syncForAllStandardOfferSets(accountId: number): Observable<void> {
    const requestUrl = `//${environment.autoDomain}:${environment.autoPort}/api/offers-registry/sync`;
    const response = this.httpClient.post<void>(requestUrl,
      {
        accountId
      },
      this.options
    ).pipe(
      catchError(this.handleError)
    );

    return response;
  }
}
